import $ from 'jquery';

import Config from '../config';
import Url from '../urlify';

import { requestBegins, requestEnds, beginLock, endLock } from '../loader';





const get = request( 'get' );
const pst = request( 'post' );
const ptc = request( 'patch' );
const put = request( 'put' );
const del = request( 'delete' );

export { get, pst, ptc, put, del };

window.get = get;

function request(method) {
    return url => 
        extendRequest( ({ sealed, hidden, body, blocking, view, tokenize = false, basify = false }, ...params) => 
            new Promise( (resolve, reject) => {
                if (!params.length)
                    params = [{}];

                const parsedUrl = new Url( url );

                if (!sealed)
                    for (let pi of params)
                        parsedUrl.substitute( pi );

                if (!hidden)
                    requestBegins();
                if (blocking)
                    beginLock( view );
                
                $.ajax( {
                    method,
                    contentType: 'application/json; charset=UTF-8',
                    data: body ? JSON.stringify( body ) : 
                        ['post', 'put', 'patch'].includes( method ) ? '{}' : undefined,
                    url: Config.url( parsedUrl.toString(), { addToken: tokenize, addBase: basify } ),
                    success: response => (!hidden && requestEnds(), 
                        blocking && endLock( view ),
                        resolve( [response, response, ...params] ) ),
                    error: (...errors) => (!hidden && requestEnds(), 
                        blocking && endLock( view ),
                        reject( [errors] ) )
                } );
            } ) );
}

function extendRequest(fn) {
    fn.options = options0 => extendRequest( ({ ...options }, ...params) => fn( { ...options0, ...options }, ...params ) );

    fn.sealed = () => fn.options( { sealed: true } );

    fn.hidden = () => fn.options( { hidden: true } );

    fn.body = body => fn.options( { body } );

    fn.cerebellum = () => fn.options( { tokenize: true, basify: true } );

    fn.mapsurfer = () => fn.options( { tokenize: true } );

    fn.blocking = view => fn.options( { blocking: true, view } );

    return extendResponse( fn );
}

function extendResponse(func) {

    func.reduce = (fn, f0, zero) => extendResponse( (...params) => func( ...params )
        .then( ([result, response, ...others]) => {
            if (result === undefined)
                return [result, response, ...others];

            if (typeof result.reduce !== 'function')
                return [f0( result, response, ...others ), response, ...others];

            const reduceFn = (cu, el, i) => fn( cu, el, i, result, response, ...others );
            return [result.reduce( reduceFn, zero ), response, ...others];
        } ) );

    func.chain = f => extendResponse( (...params) => func( ...params )
        .then( ([result0, response0, ...others]) => {
            if (!result0)
                return [result0, response0, ...others];

            let fResult = f( result0, response0, ...others );
            if (fResult.execute)
                fResult = fResult.execute( ...params );

            return fResult.then( response => [response, response, result0, ...others] );
        } ) );

    func.execute = (...params) => func( {}, ...params )
        .then( ([result/*, ...tail*/]) => result );

    func.map = f => func.reduce( 
        (cu, el, ...args) => [...cu, f( el, ...args )], 
        (el, ...args) => f( el, ...args ), 
        [] );

    func.filter = f => func.reduce( 
        (cu, el, ...args) => f( el, ...args ) ? [...cu, el] : cu, 
        (el, ...args) => f( el, ...args ) ? el : undefined, 
        [] );

    func.concat = () => func.reduce( 
        (cu, el) => [...cu, ...el], 
        // stub fn: must be never called
        (cu, el) => [...cu, ...el], 
        [] );

    func.peek = f => func.reduce( 
        (cu, el, ...args) => (f( el, ...args ), [...cu, el]), 
        (el, ...args) => (f( el, ...args ), el), 
        [] );

    return func;
}


// WEBPACK FOOTER //
// ./src/js/http/api.js